export default __webpack_public_path__ + "static/media/here2help.14c0ff22.png";